'use client';

import { useRef } from 'react';
import clx from 'classnames';

import styles from './Pill.module.scss';
import { PillProps } from './types';

export function Pill({ showIcon = true, icon = '&times;', className = '', ...props }: PillProps) {
	let ref = useRef(null);
	let { children } = props;

	return (
		<button className={clx(styles.pillWrapper, className)} ref={ref}>
			<span>{children}</span>
			{showIcon ? (
				<span
					aria-hidden="true"
					className={styles.icon}
					{...(typeof icon === 'string' ? { dangerouslySetInnerHTML: { __html: icon } } : {})}
				>
					{typeof icon !== 'string' ? icon : null}
				</span>
			) : null}
		</button>
	);
}
